import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { LocationQuery } from 'vue-router';
import { JointCommittee, JointCommitteeWorkerStatute } from './joint-committee.interface';

export class JointCommitteeService {
   async getJointCommittees(query?: LocationQuery) {
      const response = await http.get<PaginatedResponse<JointCommittee>>(`/joint-committees`, {
         ...cacheFirstConfig,
         params: { ...query },
      });
      return response.data;
   }

   async getJointCommitteeByNumber(number: number) {
      return await http.get(`c/${number}`).then((response) => response.data);
   }

   async getJointCommitteeByCompanyID(companyId: number) {
      return await http.get(`/companies/${companyId}/joint-committees`).then((response: any) => {
         return response.data.data;
      });
   }

   async postCompanyJointCommittees(companyId: number, jointCommitteeId: any) {
      return await http.post(`/companies/${companyId}/joint-committees/${jointCommitteeId}`).then((response: any) => {
         return response.data;
      });
   }

   async deleteCompanyJointCommittees(companyId: number, jointCommitteeId: any) {
      return await http.delete(`/companies/${companyId}/joint-committees/${jointCommitteeId}`).then((response: any) => {
         return response.data;
      });
   }

   async getJointCommitteeWorkerStatutes(query?: LocationQuery) {
      const response = await http.get<PaginatedResponse<Array<JointCommitteeWorkerStatute>>>(`/joint-committees-worker-statutes`, {
         ...cacheFirstConfig,
         params: { ...query },
      });

      return response.data.data;
   }
}
